// Geocities Sparkle Cursor Trail
(function () {
  var SPARKLES = ['⭐', '✨', '💫', '⚡', '🌟', '★', '✦', '✧', '✩', '☆'];
  var COLORS   = ['#ff0000', '#ff8800', '#ffff00', '#00ff00', '#00ffff', '#0088ff', '#ff00ff', '#ffffff', '#ff69b4'];
  var lastTime = 0;

  document.addEventListener('mousemove', function (e) {
    var now = Date.now();
    if (now - lastTime < 55) return;
    lastTime = now;

    var el = document.createElement('div');
    el.className = 'geo-sparkle';
    el.style.left  = e.clientX + 'px';
    el.style.top   = e.clientY + 'px';
    el.style.color = COLORS[Math.floor(Math.random() * COLORS.length)];
    el.style.marginLeft = ((Math.random() - 0.5) * 24) + 'px';
    el.style.marginTop  = ((Math.random() - 0.5) * 24) + 'px';
    el.textContent = SPARKLES[Math.floor(Math.random() * SPARKLES.length)];

    document.body.appendChild(el);
    setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, 750);
  });
})();
